var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Results = function Results(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M3 2a1 1 0 0 1 1 1v17h17a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "m18.586 8-3.856 3.856-5.414-1.805a1 1 0 0 0-1.173.434l-3 5a1 1 0 0 0 1.714 1.03l2.588-4.313 5.239 1.747a1 1 0 0 0 1.023-.242L20 9.414V14a1 1 0 1 0 2 0V7.001l-.001-.049A.996.996 0 0 0 21 6h-7a1 1 0 1 0 0 2h4.586Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default Results;